"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _subscriptionTypes = require("./subscriptionTypes");

var _subscriptionTypes2 = _interopRequireDefault(_subscriptionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _subscriber = {
	handlepublication: function handlepublication(publication) {
		if (typeof this.callback === "function") this.callback(publication);
	},
	handleLatestpublication: function handleLatestpublication(publication) {
		if (this.options[_subscriptionTypes2.default.REACT_TO_LATEST]) {
			this.handlepublication(publication);
		}
	}
};

var createSubscriber = function createSubscriber(callback, options) {
	var subscriber = Object.create(_subscriber);
	subscriber.timeStamp = Date.now();
	subscriber.callback = callback;
	subscriber.options = options || {};
	return subscriber;
};

exports.default = createSubscriber;